export const statusTypes = ['uploaded', 'in_progress', 'error', 'processed']

export const getTitle = (status) => {
  if (!statusTypes.includes(status)) return ''

  switch (status) {
    case 'uploaded':
      return 'dashboard_uploaded'
    case 'in_progress':
      return 'dashboard_in-progress'
    case 'error':
      return 'dashboard_error'
    case 'processed':
      return 'dashboard_processed'
    default:
      return ''
  }
}
